import { useParams } from 'react-router';

import TermsOfServiceJa from './ja';
import TermsOfServiceKo from './ko';
import TermsOfServiceTh from './th';
import TermsOfServiceZh from './zh';

const TermsOfService = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <TermsOfServiceTh />;
  else if (language === 'zh') return <TermsOfServiceZh />;
  else if (language === 'ja') return <TermsOfServiceJa />;
  return <TermsOfServiceKo />;
};

export default TermsOfService;
